export const COLLAB_STATUSES = [
  { value: 'PLANNED',     label: 'Ожидает' },
  { value: 'IN_PROGRESS', label: 'Активен' },
  { value: 'COMPLETED',   label: 'Завершён' },
];

export const COLLAB_STATUS_LABELS = {
  PLANNED:        'Ожидает',
  AWAITING_START: 'Ожидание старта',
  IN_PROGRESS:    'Активен',
  COMPLETED:      'Завершён',
  CANCELLED:      'Отменена',
};
